import { defineNuxtPlugin } from '#app/nuxt'
import { LazyUiBreadCrumbs, LazyUiTable, LazyLayoutSidebar, LazyLayoutTable, LazyImageWithText, LazyText, LazyUiAccordion, LazyUiAlgoliaSearchResults, LazyUiBacklink, LazyUiBard, LazyUiButton, LazyUiCheckbox, LazyUiFuseSearchResults, LazyUiImportContentBard, LazyUiImportSectionsBard, LazyUiIsOffline, LazyUiLoadingIndicator, LazyUiMobileBar, LazyUiMultiselect, LazyUiSearchResults, LazyUiSidebarNavToggler, LazyUiToggle, LazyBreaky, LazyComponentsLoader, LazyLangSwitcher, LazyTableCell, LazyTableHeadCell, LazyTableRow, LazyTouchTarget, LazyViewporter, LazyIconArrowBack, LazyIconArrowRight, LazyIconBrain, LazyIconBurger, LazyIconChevron, LazyIconClose, LazyIconDrip, LazyIconFullLogo, LazyIconGearwheel, LazyIconHomeLogo, LazyIconHomeLogoSiluette, LazyIconInfo, LazyIconLogo, LazyIconLogoLoading, LazyIconPill, LazyIconSearch, LazyIconX, LazyNavigationMain, LazyNavigationMainDesktop, LazyNavigationMainMobile, LazyNavigationTab } from '#components'
const lazyGlobalComponents = [
  ["UiBreadCrumbs", LazyUiBreadCrumbs],
["UiTable", LazyUiTable],
["LayoutSidebar", LazyLayoutSidebar],
["LayoutTable", LazyLayoutTable],
["ImageWithText", LazyImageWithText],
["Text", LazyText],
["UiAccordion", LazyUiAccordion],
["UiAlgoliaSearchResults", LazyUiAlgoliaSearchResults],
["UiBacklink", LazyUiBacklink],
["UiBard", LazyUiBard],
["UiButton", LazyUiButton],
["UiCheckbox", LazyUiCheckbox],
["UiFuseSearchResults", LazyUiFuseSearchResults],
["UiImportContentBard", LazyUiImportContentBard],
["UiImportSectionsBard", LazyUiImportSectionsBard],
["UiIsOffline", LazyUiIsOffline],
["UiLoadingIndicator", LazyUiLoadingIndicator],
["UiMobileBar", LazyUiMobileBar],
["UiMultiselect", LazyUiMultiselect],
["UiSearchResults", LazyUiSearchResults],
["UiSidebarNavToggler", LazyUiSidebarNavToggler],
["UiToggle", LazyUiToggle],
["Breaky", LazyBreaky],
["ComponentsLoader", LazyComponentsLoader],
["LangSwitcher", LazyLangSwitcher],
["TableCell", LazyTableCell],
["TableHeadCell", LazyTableHeadCell],
["TableRow", LazyTableRow],
["TouchTarget", LazyTouchTarget],
["Viewporter", LazyViewporter],
["IconArrowBack", LazyIconArrowBack],
["IconArrowRight", LazyIconArrowRight],
["IconBrain", LazyIconBrain],
["IconBurger", LazyIconBurger],
["IconChevron", LazyIconChevron],
["IconClose", LazyIconClose],
["IconDrip", LazyIconDrip],
["IconFullLogo", LazyIconFullLogo],
["IconGearwheel", LazyIconGearwheel],
["IconHomeLogo", LazyIconHomeLogo],
["IconHomeLogoSiluette", LazyIconHomeLogoSiluette],
["IconInfo", LazyIconInfo],
["IconLogo", LazyIconLogo],
["IconLogoLoading", LazyIconLogoLoading],
["IconPill", LazyIconPill],
["IconSearch", LazyIconSearch],
["IconX", LazyIconX],
["NavigationMain", LazyNavigationMain],
["NavigationMainDesktop", LazyNavigationMainDesktop],
["NavigationMainMobile", LazyNavigationMainMobile],
["NavigationTab", LazyNavigationTab],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
